// extracted by mini-css-extract-plugin
module.exports = {"topLeft":"styles_topLeft__1jAPq","title":"styles_title__3wKa2","seriesTitle":"styles_seriesTitle__3QQDK","upNext":"styles_upNext__1uRpO","topDarken":"styles_topDarken__1cPVh"};